/* =========================================================
   MYSTIC MOON — Révélation douce du contenu au scroll
   Réutilise l'observateur natif Be Yours theme.initWhenVisible (global.js).
   NE réécrit PAS d'IntersectionObserver.

   Sûreté (progressive enhancement) :
   - Si theme.initWhenVisible absent  -> on ne fait rien (contenu visible).
   - prefers-reduced-motion: reduce    -> on ne fait rien (contenu visible).
   - Sections déjà (presque) à l'écran  -> pas de .mm-reveal (zéro flash).
   - Configurateur (#bracelet-life-path) EXCLU (il a ses propres animations).
   ========================================================= */
(function () {
  if (!window.theme || typeof theme.initWhenVisible !== "function") return;
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  function init() {
    var main = document.getElementById("MainContent");
    if (!main) return;

    // Page configurateur : on ne révèle RIEN. Le configurateur ET ses sections
    // sœurs (réassurance/FAQ d'entrée) sont masqués/réaffichés selon l'état
    // form <-> result ; y poser .mm-reveal risquerait de laisser une section
    // bloquée à opacity:0 après un aller-retour résultat -> form. Page intacte.
    if (main.querySelector("#bracelet-life-path")) return;

    var sections = main.querySelectorAll(":scope > .shopify-section");
    var vh = window.innerHeight || document.documentElement.clientHeight;

    Array.prototype.forEach.call(sections, function (sec) {
      // Exclusions : configurateur (animations dédiées) + sections vides.
      if (sec.querySelector("#bracelet-life-path")) return;
      if (!sec.firstElementChild) return;

      // Sections déjà visibles au chargement : on les laisse telles quelles.
      if (sec.getBoundingClientRect().top < vh * 0.85) return;

      sec.classList.add("mm-reveal");
      theme.initWhenVisible({
        element: sec,
        threshold: 0,
        callback: function () {
          sec.classList.add("mm-reveal--in");
        }
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
